import type React from 'react';
import useUserRole from '../../components/activeUser';

interface UserRoleCheckerProps {
  children: (userRole: string | null) => React.ReactNode;
}

const UserRoleChecker: React.FC<UserRoleCheckerProps> = ({ children }) => {
  const userRole = useUserRole(); // Use the useUserRole hook to get the user's role
  return children(userRole);
};

export default UserRoleChecker;
